module.exports = __webpack_public_path__ + "static/media/frames-5.114723cf.jpg";